export const INOPLA_APIS = [
  "/CDR",
  "/Numbers",
  "/Files/Record",
  "/Files/Record/{recordId}",
  "/Routing",
];
